// 设置Cookie
function setCookie(key, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    key +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
}

// 获取Cookie
function getCookie(key) {
  var arrstr = document.cookie.split('; ');
  for (var i = 0; i < arrstr.length; i++) {
    var temp = arrstr[i].split('=');
    if (temp[0] == key) {
      return unescape(temp[1]);
    }
  }
}

// 清除Cookie
function delCookie(key) {
  var exdate = new Date();
  exdate.setTime(exdate.getTime() + -1 * 24 * 60 * 60 * 1000);
  var cookieVal = getCookie(key);
  document.cookie = key + '=' + cookieVal + '; expires=' + exdate.toGMTString();
}

//格式化时间
function formatTime(value) {
  let date = new Date(value);
  let year = date.getFullYear();
  let month =
    date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1;
  let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  let minutes =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  let seconds =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  return (
    year +
    '年' +
    month +
    '月' +
    day +
    '日' +
    ' ' +
    hours +
    ':' +
    minutes +
    ':' +
    seconds
  );
}

/**
 * @Author    康松
 * @copyright [获取客户端的年月日星期时分秒]
 * @return    {[object]}
 */
function getClientTimeAll() {
  var oDate = new Date();
  var sYear = oDate.getFullYear();
  var sMonth = oDate.getMonth() + 1;
  var sDay = oDate.getDate();
  var sWeek = oDate.getDay();
  var sHour = oDate.getHours();
  var sMinute = oDate.getMinutes();
  var sSecond = oDate.getSeconds();
  sMonth = sMonth >= 10 ? sMonth : '0' + sMonth;
  sDay = sDay >= 10 ? sDay : '0' + sDay;
  sHour = sHour >= 10 ? sHour : '0' + sHour;
  sMinute = sMinute >= 10 ? sMinute : '0' + sMinute;
  sSecond = sSecond >= 10 ? sSecond : '0' + sSecond;
  return {
    year: sYear,
    month: sMonth,
    day: sDay,
    week: sWeek ? sWeek : 7,
    hour: sHour,
    minute: sMinute,
    second: sSecond,
  };
}

function isIE() {
  //ie?
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
}
// 防抖
export function debounce(fn, wait) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, wait);
  };
}
export function dateFormat(fmt, timestamp) {
  const date = new Date(timestamp);
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
      );
    }
  }
  return fmt;
}
// 重命名
function uuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';
  var uuid = s.join('');
  return uuid;
}

// 本地文件转base64
function pathToBase64(file) {
  try {
    var type = file.slice(file.lastIndexOf('.') + 1);
    var xmlHttp = new ActiveXObject('MSXML2.XMLHTTP.6.0'); // 要用MSXML2.XMLHTTP.6.0，不要用MSXML2.XMLHTTP（会报错"没有权限"）
    xmlHttp.open('POST', file, false);
    xmlHttp.send('');
    var xml_dom = new ActiveXObject('MSXML2.DOMDocument');
    var tmpNode = xml_dom.createElement('tmpNode');
    tmpNode.dataType = 'bin.base64';
    tmpNode.nodeTypedValue = xmlHttp.responseBody;
    var fileBase = '';
    switch (type) {
      case 'pdf':
        fileBase = 'data:application/pdf;base64,';
        break;
      case 'jpg':
        fileBase = 'data:image/jpg;base64,';
        break;
      case 'png':
        fileBase = 'data:image/png;base64,';
        break;
      case 'bmp':
        fileBase = 'data:image/bmp;base64,';
        break;
    }
    var imgBase64Data = fileBase + tmpNode.text.replace(/\n/g, '');
    return imgBase64Data;
  } catch (e) {
    console.log('pathToBase64 error:', JSON.stringify(e));
    return false;
  }
}

//base64转File(IE)
function dataURLtoFile(dataurl) {
  if (!dataurl) {
    console.log('文件路径不存在');
    return false; //文件路径不存在
  }
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  var theBlob = new Blob([u8arr], { type: mime });
  theBlob['lastModifiedDate'] = new Date();
  return theBlob;
}

// base64转Blob转换
export const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: contentType });
}

// 删除本地文件
function deleteFiles(clientFile) {
  let fso = new ActiveXObject('Scripting.FileSystemObject');
  if (clientFile) {
    fso.DeleteFile(clientFile);
  }
}

// 获取url参数
function getUrlParams (url = window.location.href) {
  const paramArr = url.slice(url.indexOf("?") + 1).split("&");
  return paramArr.reduce((pre, cur) => {
    const [key, val] = cur.split("=");
    pre[key] = decodeURIComponent(val);
    return pre;
  }, {});
}

function getChromeVersion() {
  return new RegExp('Chrome/(\\d+)').exec(navigator.appVersion) ? new RegExp('Chrome/(\\d+)').exec(navigator.appVersion)[1] : -1; // -1为非Chrome浏览器内核
}

// 文件下载到本地
function  downloadFile(url, fileName ) {
  const el = document.createElement('a');
  el.style.display = 'none';
  el.setAttribute('target', '_blank');
  fileName && el.setAttribute('download', fileName);
  el.href = url;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
}



export default {
  getCookie,
  setCookie,
  delCookie,
  formatTime,
  getClientTimeAll,
  debounce,
  isIE,
  uuid,
  pathToBase64,
  dataURLtoFile,
  deleteFiles,
  getUrlParams,
  getChromeVersion,
  downloadFile
};
